import { Box, Chip, Icon, IconButton, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { FolderAccessType, FolderDto, UserDto } from "../../../api/psc";
import { RootState } from "../../../slices/Store";

// updated
export default function FolderItem(props: {
    folder: FolderDto;
    onEdit: (user: UserDto) => void;
    onDelete: (user: UserDto) => void;
}) {
    const sharedState = useSelector((state: RootState) => state.shared);

    return (
        <Paper
            sx={{
                mb: 2,
                display: "flex",
                flexDirection: "row",
                px: 2,
                py: 1,
                alignItems: "center",
                gap: 1,
            }}
        >
            <Icon sx={{ color: `#` + props.folder.color }}>folder</Icon>

            <Typography color="text.primary">{props.folder.title}</Typography>

            {props.folder.accessType === FolderAccessType.PUBLIC && (
                <Chip label="عمومی" size="small" color="success" />
            )}

            {props.folder.accessType === FolderAccessType.PRIVATE && (
                <Chip label="خصوصی" size="small" color="warning" />
            )}

            <Box sx={{ flexGrow: 1 }} />

            <IconButton
                color="warning"
                onClick={() => props.onDelete(props.folder)}
            >
                <Icon>delete</Icon>
            </IconButton>

            <IconButton
                color="secondary"
                onClick={() => props.onEdit(props.folder)}
            >
                <Icon>edit</Icon>
            </IconButton>
        </Paper>
    );
}
